import {Box, Dialog, Typography} from "@mui/material";
import {DeleteForever as DeleteForeverIcon, Warning as WarningIcon} from "@mui/icons-material";
// @ts-ignore — untyped JS helper (TODO(ts-migration): convert CacheRtl.js)
import {RTL} from "../../../cache/CacheRtl";
// @ts-ignore — untyped JS design tokens (TODO(ts-migration): convert coachTokens.js)
import {t} from "../../dashboard/coach/coachTokens";

interface Props {
    open: boolean;
    name: string;
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * Confirm permanently deleting a trainee's PERSONAL measurement.
 *
 * Unlike the company-catalog delete dialog there is no impact fetch and no hide-vs-delete choice:
 * hiding is a separate action on the row, and this path is always the irreversible one. The
 * warning has to carry that weight on its own.
 *
 * `<RTL>` goes INSIDE `<Dialog>` — the dialog renders through a Portal, which escapes the page's
 * RTL cache.
 */
const DeletePersonalMeasurementDialog = ({open, name, onCancel, onConfirm}: Props) => (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth
            PaperProps={{sx: {borderRadius: t.r, p: "20px"}}}>
        <RTL>
            <Box dir="rtl" sx={{display: "flex", flexDirection: "column", gap: "14px"}}>
                <Box sx={{display: "flex", alignItems: "center", gap: "10px"}}>
                    <Box sx={{
                        width: 34, height: 34, borderRadius: t.rs, flexShrink: 0,
                        background: t.redLight, color: t.red,
                        display: "flex", alignItems: "center", justifyContent: "center",
                    }}>
                        <WarningIcon sx={{fontSize: 19}}/>
                    </Box>
                    <Typography sx={{fontSize: "15px", fontWeight: 700, color: t.text}}>
                        מחיקת מדד אישי
                    </Typography>
                </Box>

                <Typography sx={{fontSize: "13px", color: t.t2, lineHeight: 1.6}}>
                    פעולה זו תמחק את <strong>{name}</strong> ואת <strong>כל הנתונים</strong> שנרשמו
                    עבורו למתאמן זה. <strong>לא ניתן לשחזר.</strong>
                </Typography>

                <Typography sx={{fontSize: "12px", color: t.t3, lineHeight: 1.6}}>
                    אם רק אינך רוצה שהמדד יופיע למתאמן — השתמש ב״הסתר״ במקום. הנתונים יישמרו וניתן
                    יהיה להציג אותו שוב בכל עת.
                </Typography>

                <Box sx={{display: "flex", gap: "8px", justifyContent: "flex-start", mt: "4px"}}>
                    <Box
                        component="button"
                        onClick={onConfirm}
                        sx={{
                            display: "inline-flex", alignItems: "center", gap: "5px",
                            height: 36, px: "14px", borderRadius: t.rs,
                            background: t.red, color: "#fff", border: "none",
                            fontSize: "13px", fontWeight: 700, fontFamily: "inherit",
                            cursor: "pointer", transition: "all .14s",
                            "&:hover": {filter: "brightness(.94)"},
                        }}
                    >
                        <DeleteForeverIcon sx={{fontSize: 16}}/>
                        מחק לצמיתות
                    </Box>
                    <Box
                        component="button"
                        onClick={onCancel}
                        sx={{
                            height: 36, px: "14px", borderRadius: t.rs,
                            background: t.white, color: t.t2, border: `1px solid ${t.border}`,
                            fontSize: "13px", fontWeight: 600, fontFamily: "inherit",
                            cursor: "pointer", transition: "all .14s",
                            "&:hover": {background: t.bg},
                        }}
                    >
                        ביטול
                    </Box>
                </Box>
            </Box>
        </RTL>
    </Dialog>
);

export default DeletePersonalMeasurementDialog;
